import React from 'react';
import PropTypes from 'prop-types';

/**
 * Composant ButtonGroup pour regrouper les boutons
 * Utilise le système de classes CSS wa-button-group
 */
const ButtonGroup = ({ children, className = '', ...props }) => {
  const groupClasses = ['wa-button-group', className].filter(Boolean).join(' ');

  return (
    <div className={groupClasses} {...props}>
      {children}
    </div>
  );
};

ButtonGroup.propTypes = {
  /** Boutons enfants */
  children: PropTypes.node.isRequired,
  /** Classes CSS supplémentaires */
  className: PropTypes.string,
};

export default ButtonGroup;
